import { Box, Button } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllOrgs = () => {
  const [orgs, setOrgs] = useState([]);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const getOrgs = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOrgs(res.data);
    };
    getOrgs();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, date] = dateString.split("-");
    return `${date}/${month}/${year}`;
  };
  const columns = [
    {
      field: "orgId",
      headerName: "Org ID",
      flex: 1,
    },
    {
      field: "orgName",
      headerName: "Org Name",
      flex: 1,
    },
    {
      field: "adminEmail",
      headerName: "Admin Email",
      flex: 1,
    },
    {
      field: "adminMobile",
      headerName: "Admin Mobile",
      flex: 1,
    },
    {
      field: "subscriptionStartDate",
      headerName: "Subscription Start Date",
      flex: 1,
      renderCell: (params) => formatDate(params.row.subscriptionStartDate),
    },
    {
      field: "subscriptionEndDate",
      headerName: "Subscription End Date",
      flex: 1,
      renderCell: (params) => formatDate(params.row.subscriptionEndDate),
    },
    {
      field: "action",
      headerName: "Action",

      width: 250,
      renderCell: (params) => (
        <Box sx={{ display: "inline-flex", gap: 1 }}>
          <Button
            className="btn-contained"
            sx={{ width: "100px", margin: "0 !important", fontSize: "12px" }}
            onClick={() =>
              navigate(`/superadmin-dashboard/${params.row.orgId}`)
            }
          >
            Edit Org
          </Button>
          <Button
            className="btn-contained"
            sx={{ width: "100px", margin: "0 !important", fontSize: "12px" }}
            onClick={() =>
              navigate(`/superadmin-dashboard/${params.row.orgId}/admin`)
            }
          >
            Edit Admin
          </Button>
        </Box>
      ),
    },
  ];

  const rows = orgs ? orgs : "";
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end", columnGap: 10 }}>
        <Button
          className="btn-contained"
          onClick={() => navigate("/superadmin-dashboard/create-org")}
        >
          + Create Org
        </Button>
      </div>
      <div className="dashboard-container">
        <h1>List of Organizations</h1>
        <Box sx={{ background: "#fff" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => row.orgId}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            sx={{
              position: "relative",
              border: "none",
              fontFamily: "Inter !important",

              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "700 !important",
              },
              "& .MuiDataGrid-columnHeaders": {
                background: "none !important",
                color: "black",
                fontSize: "14px",
                borderRadius: "10px",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#fff",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13px",
                border: "none",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },
              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },
              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#EAF4FF",
                // '&:hover': {
                //   backgroundColor: "#f6f6f6",
                // },
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default AllOrgs;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
